// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"MainContentQuartoCadastroDeadline_sectionTitle__2BpIf","placeholderShimmer":"MainContentQuartoCadastroDeadline_placeholderShimmer__3C4d0"};